module.exports = __webpack_public_path__ + "static/media/pay_way2.e4c7229c.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/pay_way2.png
// module id = 1514
// module chunks = 10